import Logger from './Logger';

function fetchNewScript() {
  return new Promise((resolve, reject) => {
    try {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = false;
      script.src =
        '//staticw2.yotpo.com/MtI6WMUc1SMDm8DW3ZmRDSTA4TUsLomtzi81ZY7C/widget.js';

      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(script, s);
      script.addEventListener('load', () => {
        resolve();
      });
      document.head.appendChild(script);
    } catch (err) {
      Logger.warn(
        'Yotpo could not be initialized with fetchNewScript. Moving on.',
        err,
      );
      reject();
    }
  });
}

function runScriptWhenIdIsPresent(id) {
  if (document.getElementById(id)) {
    if (window.yotpo) {
      try {
        const refreshWidgets = window.yotpo
          ? window.yotpo.refreshWidgets.bind(window.yotpo)
          : () => {};
        refreshWidgets();
      } catch (err) {
        Logger.warn(
          'Yotpo could not be initialized with runScriptWhenIdIsPresent. Moving on.',
          err,
        );
      }
    } else {
      fetchNewScript().then();
    }
  }
}

function initializeScript() {
  if (!window.yotpo) {
    fetchNewScript().then();
  }
}

export default {
  runScriptWhenIdIsPresent,
  initializeScript,
};
